import script from "./QueryPOIView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryPOIView.vue?vue&type=script&setup=true&lang=js"

import "./QueryPOIView.vue?vue&type=style&index=0&id=720cda5a&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-720cda5a"]])

export default __exports__